import { showAlert } from '../../../actions/radminUploads';
import API from '../../../libs/api';
import { store } from '../../../reducers/store';


const getErrorMessages = (err) => {
  const detail = err?.response?.data?.detail;

  if (!detail) return ['Something went wrong'];

  if (typeof detail === 'string') {
    if (detail === 'Invalid token for given user.') {
      return ['This reset link has expired. Please request a new one.'];
    }

    return [detail];
  }

  if (typeof detail === 'object') {
    const values = Object.values(detail).flat();

    return values.map((msg) => {
      if (msg === 'Invalid token for given user.') {
        return 'This reset link has expired. Please request a new one.';
      }
      return msg;
    });
  }

  return ['Something went wrong'];
};

async function resetPasswordRequest({ email, dispatch }) {
  try {
    dispatch({
      type: 'PASSWORD_REQUEST',
    });

    await API.postRequest(`/auth/users/reset_password/`, {
      email,
    });

    dispatch({
      type: 'PASSWORD_REQUEST_SUCCESS',
    });
  } catch (err) {
    const status = err?.response?.status;
    const code = err?.response?.data?.code;

    if (status === 403) {
      dispatch({
        type: 'PASSWORD_REQUEST_FAILURE',
        payload: [
          'Admin panel has an active session. Please log out from there and try again.',
        ],
      });
    } else {
      dispatch({
        type: 'PASSWORD_REQUEST_FAILURE',
        payload: getErrorMessages(err),
      });
    }
  }
}

async function resetPasswordConfirm({
  uid,
  token,
  password,
  history,
  dispatch,
  isLoggedIn,
  logout,
}) {
  try {
    dispatch({
      type: 'PASSWORD_REQUEST',
    });

    await API.postRequest(`/auth/users/reset_password_confirm/`, {
      uid,
      token,
      new_password: password,
    });

    dispatch({
      type: 'PASSWORD_REQUEST_SUCCESS',
    });

    if (isLoggedIn) {
      await logout();
    }
    store.dispatch(showAlert('success', 'Success', 'Password changed successfully!'));
    history.push('/login');
  } catch (err) {
    dispatch({
      type: 'PASSWORD_REQUEST_FAILURE',
      payload: getErrorMessages(err),
    });
  }
}

export const resetPasswordInitialState = {
  isSubmitting: false,
  hasSubmitted: false,
  hasError: false,
  errors: [],
};

function resetPasswordReducer(state, action) {
  switch (action.type) {
    case 'PASSWORD_REQUEST':
      return {
        ...state,
        isSubmitting: true,
      };
    case 'PASSWORD_REQUEST_SUCCESS':
      return {
        ...state,
        hasSubmitted: true,
        isSubmitting: false,
        hasError: false,
      };
    case 'PASSWORD_REQUEST_FAILURE':
      return {
        ...state,
        hasError: true,
        isSubmitting: false,
        errors: Array.isArray(action.payload)
      ? action.payload
      : [action.payload || 'Something went wrong'],
    errorType: action.payload?.type || 'GENERIC',
      };
    default:
      return state;
  }
}

export { resetPasswordReducer, resetPasswordConfirm, resetPasswordRequest };
